var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"result-box"},[_c('img',{staticClass:"img-result",attrs:{"src":require("@/assets/images/failed.png"),"width":"134"}})])
}]

export { render, staticRenderFns }